import { LoadingButton } from '@mui/lab';
import { Box, Checkbox, FormControlLabel, Grid, Link, Paper, TextField, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import { ChangeEvent, FormEvent, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { notify } from 'reapop';
import { useAppDispatch, useAppSelector } from 'src/hooks/redux';
import { AdminCredentials } from 'src/models/admin';
import { adminLogin } from 'src/store/auth/authService';
import { clearAuthState } from 'src/store/auth/authSlice';

const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const authState = useAppSelector((state) => state.auth);
  const [credentials, setCredentials] = useState<AdminCredentials>({
    email_address: '',
    password: ''
  });

  useEffect(() => {
    if (authState.status === 'fulfilled') {
      dispatch(notify(authState.message, 'success'))
      setTimeout(() => {
        navigate(
          authState.admin?.admin_role === 'super-admin' ||
            authState.admin?.admin_role === 'system-admin'
            ? '/general/dashboard' : '/application/jobs'
        );
        dispatch(clearAuthState())
      }, 1000);
    } else if (authState.status === 'rejected') {
      dispatch(notify(authState.message, 'error'))
    }
    // eslint-disable-next-line
  }, [authState]);

  const handleFormSubmit = (e: FormEvent) => {
    e.preventDefault();
    dispatch(adminLogin(credentials));
  }

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setCredentials({ ...credentials, [name]: value });
  }

  return (
    <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
      <motion.div
        key={'loginForm'}
        initial={{ y: -100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: -100, opacity: 0 }}
        transition={{ duration: 0.8 }}
      >
        <Box
          sx={{
            my: 8,
            mx: 4,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <br />
          <br />
          <br />
          <Typography color={''} component="h1" variant="h1">
            Welcome back 👋
          </Typography>
          <Typography component={'h6'}>
            Please enter your credentials to continue...
          </Typography>
          <Box component="form" noValidate onSubmit={handleFormSubmit} sx={{ mt: 2 }}>
            <TextField
              margin="normal"
              required
              value={credentials.email_address}
              fullWidth
              name='email_address'
              onChange={handleInputChange}
              label="Email Address"
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              value={credentials.password}
              onChange={handleInputChange}
              name="password"
              label="Password"
              type="password"
            />
            <Grid component={'div'} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <FormControlLabel
                control={<Checkbox value="remember" color="primary" />}
                label={<Typography variant="body2" style={{
                  fontWeight: 600
                }} color="textSecondary">Remember Me</Typography>}
              />
              <Typography component={'p'}>
                <Link href="/forget-password" underline="none" fontWeight={'600'} variant="body2">
                  Forgot password?
                </Link>
              </Typography>
            </Grid>
            <LoadingButton
              type="submit"
              fullWidth
              loading={authState.status === 'pending'}
              loadingPosition="start"
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Sign In
            </LoadingButton>
            {/* <Copyright sx={{ mt: 5 }} /> */}
          </Box>
        </Box>
      </motion.div>
    </Grid>
  )
}

export default LoginPage